import styled from "styled-components";
import { Button } from "./Button";
import { LoadingSpinner } from "./LoadingSpinner";
import { spacing } from "@styling/sizing";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${spacing.x3}px;
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
`;

type LoadMoreButtonProps = {
  onClick: () => void;
  isLoading?: boolean;
  hasMore?: boolean;
  disabled?: boolean;
};

export const LoadMoreButton = ({ onClick, isLoading = false, hasMore = true, disabled = false }: LoadMoreButtonProps) => {
  if (!hasMore) {
    return null;
  }

  return (
    <ButtonContainer>
      <Button onClick={onClick} disabled={disabled || isLoading}>
        <ButtonContent>
          {isLoading && <LoadingSpinner size={16} borderWidth={2} />}
          {isLoading ? "Loading..." : "Load More"}
        </ButtonContent>
      </Button>
    </ButtonContainer>
  );
};

